import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useEffect, useRef } from "react";
import { fontSizes } from "../../pages/SubtitlesPage/subtitles-settings";
import clsx from 'clsx';
import { VerticalAlignBottomOutlined } from '@ant-design/icons';
import { useI18n } from 'components/I18nProvider';
import styles from './style.module.scss';
const collectParagraphs = (subtitles) => {
    const paragraphs = [];
    let currentParagraph = null;
    const fragments = [...subtitles.speech.finals, ...subtitles.speech.drafts];
    for (const fragment of fragments) {
        if (currentParagraph === null) {
            currentParagraph = { text: fragment.text, speaker: fragment.speaker };
        }
        else if (fragment.speaker !== currentParagraph.speaker) {
            paragraphs.push(currentParagraph);
            currentParagraph = { text: fragment.text, speaker: fragment.speaker };
        }
        else {
            currentParagraph.text += fragment.text;
        }
    }
    if (currentParagraph !== null) {
        paragraphs.push(currentParagraph);
    }
    return paragraphs;
};
const SubtitlesPanel = ({ subtitles, settings, speechSegmentation, autoScroll, autoScrollButton = 'big', autoscrollButtonTestId, showAutoscrollButton = true, onAutoScrollChange }) => {
    const linesRef = useRef(null);
    const { intl } = useI18n();
    const scrollText = () => {
        if (linesRef.current === null) {
            return;
        }
        const scrollHeight = linesRef.current.scrollHeight;
        const clientHeight = linesRef.current.clientHeight;
        const scrollTop = linesRef.current.scrollTop;
        if (clientHeight + scrollTop < scrollHeight) {
            linesRef.current.scrollTop += 12;
        }
    };
    useEffect(() => {
        if (!autoScroll)
            return;
        const interval = setInterval(scrollText, 25);
        return () => clearInterval(interval);
    }, [autoScroll]);
    const handleRestartAutoscroll = () => {
        onAutoScrollChange(true);
        if (linesRef.current) {
            linesRef.current.scrollTop = linesRef.current.scrollHeight;
        }
    };
    const handelAutoScrollChange = () => {
        if (autoScroll && settings.controls !== 'off') {
            onAutoScrollChange(false);
        }
    };
    const paragraphs = subtitles === 'waiting' ? [] : collectParagraphs(subtitles);
    return (_jsxs("div", { className: clsx(styles.subtitles, styles.subtitlesRelative, settings.textAlign === 'bottom' && styles.alignBottom), style: { backgroundColor: settings.bgColor }, children: [_jsx("div", { className: clsx(styles.textContent, { [styles.noUserSelect]: autoScroll }, settings.textAlign === 'bottom' && styles.textContentBottom), ref: linesRef, style: { fontSize: `${fontSizes[settings.fontSize]}em`, color: settings.textColor }, onWheel: handelAutoScrollChange, onTouchStart: handelAutoScrollChange, onMouseDown: handelAutoScrollChange, children: subtitles === 'waiting' ? (_jsx("div", { className: styles.waiting })) : (_jsx(_Fragment, { children: paragraphs.map((p, index) => (_jsxs("p", { className: styles.text, children: [speechSegmentation && _jsx("span", { children: "- " }), p.text] }, index))) })) }), _jsx("div", { className: clsx(styles.autoscrollButtonWrapper, { [styles.visible]: !autoScroll && showAutoscrollButton }), children: _jsx("button", { type: "button", "test-id": autoscrollButtonTestId, className: clsx(styles.autoscrollButton, autoScrollButton === 'small' && styles.autoscrollButtonSmall), onClick: handleRestartAutoscroll, "aria-label": intl.formatMessage({ id: 'autoscrollTooltip' }), children: _jsx(VerticalAlignBottomOutlined, {}) }) })] }));
};
export default SubtitlesPanel;
